var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#27387D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_1999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55372 5.83718C7.37559 5.88406 7.23122 5.96844 7.09997 6.09969C6.96497 6.23469 6.88434 6.37531 6.83747 6.56094C6.79997 6.70344 6.79997 6.77469 6.79997 10.0072C6.79997 13.6353 6.79434 13.4216 6.91434 13.6597C6.99122 13.8134 7.18622 14.0084 7.33997 14.0853C7.58934 14.2109 7.87997 14.2316 8.13309 14.1378C8.21934 14.1078 9.07059 13.5791 10.8987 12.4259C13.8537 10.5622 13.7393 10.6409 13.8856 10.3391C14.0487 10.0016 14.0318 9.62281 13.8406 9.29469C13.775 9.18219 13.6418 9.03781 13.5406 8.96844C13.4993 8.94031 12.6218 8.43031 11.5906 7.83406C10.5593 7.23969 9.38747 6.56094 8.98434 6.32844C8.58309 6.09594 8.19872 5.88406 8.13122 5.85968C7.96059 5.79594 7.73559 5.78656 7.55372 5.83718Z",
    fill: "#27387D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_1999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(5.59998 5.20001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.fed267eab91e0a384f553cb3bedcdc3a.svg";
export { ForwardRef as ReactComponent };